import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

const slider = {
  init() {
    this.setupSliders();
  },

  setupSliders() {
    const sliders = document.querySelectorAll('.slider .swiper');

    sliders.forEach((slider) => {
      new Swiper(slider, {
        modules: [Navigation],
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 100,
				loop: true,

        navigation: {
          nextEl: slider.parentElement.querySelector('.swiper-button-next'),
          prevEl: slider.parentElement.querySelector('.swiper-button-prev'),
        },

        breakpoints: {
          768: {
            spaceBetween: 52,
          },
        },

        a11y: {
          prevSlideMessage: 'Vorige dia',
          nextSlideMessage: 'Volgende dia',
          paginationBulletMessage: 'Ga naar dia {{index}}',
        },
      });
    });
  },
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => slider.init());
} else {
  slider.init();
}
